import React, { useMemo } from 'react';
import { getResourceTo } from 'react/utils/utils';

function RouteSizeItem({ type, plannedSize, hasOverflow, percent, equipmentsAmount }) {
  const title = useMemo(() => {
    const greaterThanMessage = getResourceTo('SpeedAssigment.routeSizeBiggerThanEquipmentSize');
    const normalMessage = greaterThanMessage.replace(' > ', '\n');

    let message = hasOverflow ? greaterThanMessage : normalMessage;
    message = message.replace('{sizeRouteValue}', plannedSize);
    message = message.replace('{sizeEquipValue}', equipmentsAmount);

    return message;
  }, [hasOverflow, plannedSize, equipmentsAmount]);

  return (
    <div data-testid={`route-size-${type}`} className={type}>
      <p>{getResourceTo(`notificationPanel.${type}`)}</p>
      <div
        data-testid={`route-size-${type}-container`}
        className={hasOverflow ? `${type}-container has-overflow` : `${type}-container`}
        title={title}
      >
        <div
          data-testid={`route-size-${type}-progress`}
          className="progress-bar"
          style={{ width: `${percent}%` }}
        />
        {hasOverflow && (
          <p data-testid={`route-size-${type}-hasoverflow-text`}>
            <b>{plannedSize}</b> &gt; {equipmentsAmount}
          </p>
        )}
        {!hasOverflow && (
          <p data-testid={`route-size-${type}-hasnot-overflow-text`}><b>{plannedSize}</b></p>
        )}
      </div>
    </div>
  );
}

export default RouteSizeItem;
